import { createTheme } from '@material-ui/core/styles';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints'

// Constants
import { limits } from './constants/limits'
import { fontSizes } from './constants/fontSizes'
import { dimensions } from './constants/dimensions'
import { palette } from './constants/palette'
import { fontFaces } from './constants/fontFaces'

const customBreakpointValues = {
  values: {
    xs: 0,
    sm: 375,
    md: 768,
    lg: 1024,
    xl: 1366,
  },
}

const breakpoints = createBreakpoints({ ...customBreakpointValues })

export const theme = createTheme({
    palette,
    breakpoints: {
      ...customBreakpointValues,
    },
    typography: {
      fontFamily: 'FuturaStd, Arial',
    },
    // Global Constants
    limits,
    fontSizes,
    dimensions
    ,
    overrides: {
      MuiCssBaseline: {
        '@global': {
          '@font-face': fontFaces,
          html: {
            WebkitFontSmoothing: 'antialiased',
            margin: '0 auto'
          },
          body: {
            backgroundColor: 'transparent',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            overflowX: 'hidden'
          },
          ".sr-only": {
            position: "absolute",
            width: "1px",
            height: "1px",
            padding: "0",
            margin: "-1px",
            overflow: " hidden",
            clip: "rect(0,0,0,0)",
            border: "0"
          },
          '.root': {
            backgroundColor: 'transparent',
            width: '100vw',
            alignItems: 'center',
            boxSizing: 'border-box',
            overflow: 'hidden',
            minHeight: '100vh',
          },
          h1: {
            fontFamily: 'Veneer, Arial',
            margin: '0',
            fontSize: 90,
            letterSpacing: 0.36,
            lineHeight: 0.89,
            fontWeight: 300
          },
          h2: {
            fontFamily: 'Veneer, Arial',
            margin: '0',
            fontSize: 80,
            letterSpacing: 0.32,
            lineHeight: 0.88,
            fontWeight: 300
          },
          h3: {
            fontFamily: 'Veneer, Arial',
            margin: '0',
            fontSize: 60,
            letterSpacing: 0.24,
            lineHeight: 0.83,
            fontWeight: 300
          },
          h4: {
            fontFamily: 'Veneer, Arial',
            margin: '0',
            fontSize: 40,
            letterSpacing: 0.16,
            lineHeight: 0.75,
            fontWeight: 300
          },
          h5: {
            fontFamily: 'Veneer, Arial',
            margin: '0',
            fontSize: 30,
            letterSpacing: 0.12,
            lineHeight: 0.9,
            fontWeight: 300
          },
          h6: {
            fontFamily: 'FuturaStd, Arial',
            margin: '0',
            fontSize: 50,
            letterSpacing: 0.3,
            lineHeight: 0.8
          },
          big:{
            fontFamily: 'FuturaStd, Arial',
            margin: '0',
            fontSize: 40,
            letterSpacing: 0.24,
            lineHeight: 1
          },
          p: {
            fontFamily: 'FuturaStd, Arial',
            margin: '0',
            fontSize: 32,
            letterSpacing: 0.19,
            lineHeight: 1.25,
            [breakpoints.down(breakpoints.values.lg)]: {
              fontSize: 24,
              letterSpacing: 0.14,
              lineHeight: 1.33
            }
          },
          small:{
            fontFamily: 'FuturaStd, Arial',
            margin: '0',
            fontSize: 18,
            letterSpacing: 0.11,
            lineHeight: 1.44
          }
        },
      },
    },
  });
